// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import React, { useRef } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function InvoiceRecordsSearch(props) {
  const { getReceivingInvoiceIndex } = props;

  var currentPage = 1;

  const searchRef = useRef();

  const handleSearch = () => {
    getReceivingInvoiceIndex(searchRef.current.value, currentPage);
  };

  const handlePagination = (newPage) => {
    currentPage = newPage;
    getReceivingInvoiceIndex(searchRef.current.value, newPage);
  };

  return (
    <div className="hide-for-print col-span-2">
      <div className="mt-2 sm:flex sm:items-center rounded-[18px] border border-[#E2E8F0] bg-white px-4 py-4 shadow-[0_1px_2px_rgba(15,23,42,0.04)] sm:px-5">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-[#0F172A] my-auto">
            Receiving Index
          </h1>
          <div className="mt-3 flex rounded-md w-128">
            <div className="relative flex items-stretch flex-grow focus-within:z-10">
              <input
                type="search"
                name="searchInput"
                id="searchInput"
                className="block w-full rounded-l-xl border border-[#E2E8F0] px-3 py-2 text-sm text-[#0F172A] placeholder:text-[#64748B]/70 focus:border-[#2563EB] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10"
                placeholder="Search by invoice #, product name, manufacturer or supplier"
                ref={searchRef}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
            </div>
            <button
              type="button"
              className="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-[#E2E8F0] text-sm font-medium rounded-r-xl text-[#0F172A] bg-white hover:bg-[#EFF6FF] focus:outline-none focus:ring-2 focus:ring-[#2563EB]/10"
              onClick={() => handleSearch()}
            >
              <MagnifyingGlassIcon
                className="h-5 w-5 text-[#64748B]/70"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
